"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basename = basename;
function basename(path) {
    if (!path) {
        return "";
    }
    const filename = filenameFrom(path);
    return nameWithoutExtensionFrom(filename);
}
function filenameFrom(path) {
    const subPaths = path.replace("\\", "/").split("/");
    return subPaths[subPaths.length - 1];
}
function nameWithoutExtensionFrom(filename) {
    const lastDotIndex = filename.lastIndexOf(".");
    if (lastDotIndex === 0 || lastDotIndex === -1) {
        return filename;
    }
    return filename.substring(0, lastDotIndex);
}
